import {
  AdminClaimManagement,
  UserClaimManagement,
  ProviderClaimManagement,
} from 'pages/claims/components';

import { useQueryClient } from '@tanstack/react-query';

import { useIsProvider, useCanAccess } from 'hooks';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';
import { useTutorialStore } from 'store/tutorialStore';
import { TutorialClaimManagement } from 'pages/claims/components';

export const ClaimManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('claims');
  const isProvider = useIsProvider();
  const { isTutorialActive } = useTutorialStore();
  const queryClient = useQueryClient();

  const determineComponent = () => {
    if (isExpired) {
      return <TokenExpired />;
    } else if (isTutorialActive) {
      return <TutorialClaimManagement queryClient={queryClient} />;
    } else if (isAdmin) {
      return <AdminClaimManagement queryClient={queryClient} />;
    } else if (isProvider) {
      return <ProviderClaimManagement queryClient={queryClient} />;
    } else if (canAccess) {
      return <UserClaimManagement queryClient={queryClient} />;
    } else {
      return <Unauthorized />;
    }
  };

  return determineComponent();
};
